var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vagaro-button"},on:{"click":function($event){return _vm.redirectToVagaro()}}},[_vm._v(" Book on Vagaro ")])
}
var staticRenderFns = []

export { render, staticRenderFns }